/**
 * Needle smoothing: critically damped spring (no overshoot). The live preview uses this, and it
 * documents the behaviour the firmware should reproduce.
 *
 * `damping_ms` is the approximate settle time: after `damping_ms` the needle has covered 98% of
 * the distance to its target. (Critically damped: 98% is reached at ≈5.83 time constants.)
 */
export const SETTLE_TIME_CONSTANTS = 5.83;
export interface NeedleState {
  pos: number;
  vel: number;
}

/** Advances the needle towards `target` by `dtMs`. damping_ms = 0 jumps straight to the target. */
export function stepNeedle(state: NeedleState, target: number, dtMs: number, dampingMs: number): NeedleState {
  if (dampingMs <= 0) return { pos: target, vel: 0 };
  // ω = 1/τ with τ = damping_ms / 5.83. Exact solution over dt (stable for any dt).
  const w = (SETTLE_TIME_CONSTANTS * 1000) / dampingMs;
  const t = dtMs / 1000;
  const x0 = state.pos - target;
  const e = Math.exp(-w * t);
  const pos = target + (x0 + (state.vel + w * x0) * t) * e;
  const vel = (state.vel - w * (state.vel + w * x0) * t) * e;
  return { pos, vel };
}
